"use client";

import React, { useState } from "react";
import axios from "axios";
import { MD5 } from "crypto-js";
import { getIcon } from "@litonarefin/utils/icons";
import { getSourceSite } from "@litonarefin/utils/getSourceSite";
import { handleToastr } from "@litonarefin/utils/handleToastr";

/**
 * Like/dislike buttons. Only this leaf needs the browser (localStorage id,
 * click handlers), so the rest of the footer stays server-rendered.
 *
 * `initialVotes` comes from the server render, so the counts are correct in
 * the first paint instead of flashing 0 while a mount effect fetches them.
 */
function DocFeedback({ docId, initialVotes }) {
  const [voteCount, setVoteCount] = useState({
    likes: initialVotes?.likes || 0,
    dislikes: initialVotes?.dislikes || 0,
  });

  const siteSource = getSourceSite();

  const getUserId = () => {
    let user_id = localStorage.getItem(`${siteSource}AuthUserId`);

    // if user not logged in
    if (null == user_id) {
      const userId = localStorage.getItem(`${siteSource}_user_id`);

      if (userId) {
        user_id = userId;
      } else {
        user_id = MD5(navigator.userAgent + Date.now()).toString();
        localStorage.setItem(`${siteSource}_user_id`, user_id);
      }
    }

    return user_id;
  };

  // Like & dislike get method
  const fetchLikeDislike = async () => {
    const { data: all } = await axios.get(
      `${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}/api/docs/like-dislike`,
      { params: { post_id: docId } }
    );

    if (all?.success) {
      setVoteCount({
        likes: all?.data?.likes || 0,
        dislikes: all?.data?.dislikes || 0,
      });
    }
  };

  // Like & dislike post method
  const likeDislike = async (type) => {
    if (!docId) return;

    const { data } = await axios.post(
      `${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}/api/docs/like-dislike`,
      {
        type: type,
        post_id: docId,
        user_id: getUserId(),
      }
    );

    if (data?.success) {
      handleToastr(
        `${type == "likes" ? "Liked" : "Disliked"} the post successfully.`,
        type == "likes" ? "success" : "error"
      );

      await fetchLikeDislike();
    } else {
      handleToastr(
        `You already ${type == "likes" ? "liked" : "disliked"} this post.`,
        type == "likes" ? "success" : "error"
      );
    }
  };

  return (
    <div className="jlt-flex jlt-flex-col md:jlt-flex-row jlt-gap-2 jlt-items-center">
      <button
        onClick={() => likeDislike("likes")}
        className="jlt-py-2 jlt-px-4 jlt-bg-[#039855] jlt-rounded jlt-flex jlt-items-center jlt-gap-2"
      >
        <span className="jlt-text-xs jlt-text-[#FFFFFF] jlt-font-semibold">
          Yes - {voteCount?.likes}
        </span>
        {getIcon("like")}
      </button>
      <button
        onClick={() => likeDislike("dislikes")}
        className="jlt-py-2 jlt-px-4 jlt-bg-[#F04438] jlt-rounded jlt-flex jlt-items-center jlt-gap-2"
      >
        <span className="jlt-text-xs jlt-text-[#FFFFFF] jlt-font-semibold">
          No - {voteCount?.dislikes}
        </span>
        {getIcon("dislike")}
      </button>
    </div>
  );
}

export default DocFeedback;
